import React from "react";

/**
 * Media card used for projects, ventures and articles.
 * `links` is a list of { href, label, Icon }.
 * `logo` fits the image inside the frame instead of cropping it, for artwork
 * that is a logo rather than a screenshot.
 */
function MediaCard({ image, kicker, title, description, links = [], logo = false }) {
  return (
    <article className="card card--interactive pcard">
      <div className={`pcard__media${logo ? " pcard__media--logo" : ""}`}>
        <img src={image} alt={`${title} preview`} loading="lazy" />
      </div>

      <div className="pcard__body">
        {kicker && <p className="pcard__kicker">{kicker}</p>}
        <h3 className="pcard__title">{title}</h3>
        <p className="pcard__text">{description}</p>

        {links.length > 0 && (
          <div className="pcard__links">
            {links.map(({ href, label, Icon }) => (
              <a
                key={label}
                href={href}
                className="pcard__link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon />
                {label}
                <span className="visually-hidden"> — {title}</span>
              </a>
            ))}
          </div>
        )}
      </div>
    </article>
  );
}

export default MediaCard;
